module.exports = __webpack_public_path__ + "img/section4_m.5a2422e8.jpg";